
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";
import { memo } from "react";

interface PieChartDataItem {
  name: string;
  value: number;
  color: string;
}

interface DistributionChartProps {
  data: PieChartDataItem[];
}

// Memoized component to prevent unnecessary re-renders
const DistributionChart = memo(({ data }: DistributionChartProps) => {
  return (
    <Card className="col-span-1">
      <CardHeader>
        <CardTitle>Distribution</CardTitle>
        <CardDescription>Analysis types breakdown</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="h-80">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={data}
                cx="50%"
                cy="50%"
                innerRadius={60}
                outerRadius={90}
                paddingAngle={2}
                dataKey="value"
                isAnimationActive={false} // Disable animations for better performance
                label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
              >
                {data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Pie>
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
});

DistributionChart.displayName = "DistributionChart";

export default DistributionChart;
